const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPdfCard(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Icon/Card/PDF",
    xmlns: "http://www.w3.org/2000/svg",
    width: 57,
    height: 57,
    viewBox: "0 0 57 57",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "#e0e0e0",
      strokeMiterlimit: 10,
      fill: "#fff"
    }
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 28,
    r: 28,
    style: {
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 28,
    r: 27.5,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Icon/PDF/36pt"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25617"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13610",
    d: "M20.172 3a2 2 0 0 1 1.414.586l7.828 7.828A2 2 0 0 1 30 12.828V30a3.009 3.009 0 0 1-3 3H8.985A3 3 0 0 1 6 30V6a3.009 3.009 0 0 1 3-3zM21 4.75v5.75a1.5 1.5 0 0 0 1.5 1.5h5.75z",
    style: {
      fill: "#dd1d01",
      fillRule: "evenodd"
    },
    transform: "translate(10 10)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13611",
    d: "M9.395 24v-7.824h2.688a5.31 5.31 0 0 1 1.212.132 2.6 2.6 0 0 1 .984.42 1.972 1.972 0 0 1 .66.78 2.534 2.534 0 0 1 .252 1.188 2.627 2.627 0 0 1-.252 1.188 2.247 2.247 0 0 1-.66.828 2.835 2.835 0 0 1-.972.48 4.306 4.306 0 0 1-1.176.156h-.972V24zm1.764-4.056h.864q1.44 0 1.44-1.248a.955.955 0 0 0-.384-.864 2.013 2.013 0 0 0-1.1-.252h-.816zM16.043 24v-7.824h2.208a5.355 5.355 0 0 1 1.62.228 3.209 3.209 0 0 1 1.236.708 3.03 3.03 0 0 1 .792 1.2 4.933 4.933 0 0 1 .276 1.74A5.034 5.034 0 0 1 21.9 21.8a3.3 3.3 0 0 1-.78 1.236 3.238 3.238 0 0 1-1.212.72 4.766 4.766 0 0 1-1.56.24zm1.764-1.428h.336a2.954 2.954 0 0 0 .912-.132 1.714 1.714 0 0 0 .7-.42 2 2 0 0 0 .444-.78 3.63 3.63 0 0 0 .168-1.188 3.478 3.478 0 0 0-.168-1.164 1.791 1.791 0 0 0-.444-.756 1.608 1.608 0 0 0-.7-.408 3.228 3.228 0 0 0-.912-.12h-.336zM23.16 24v-7.824h4.932v1.488h-3.168v1.812h2.712v1.488h-2.712V24z",
    style: {
      fill: "#fff"
    },
    transform: "translate(10 10)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdfCard);
export default __webpack_public_path__ + "static/media/pdf-card.61749c14e67e79df4aa041e26227ad7e.svg";
export { ForwardRef as ReactComponent };